<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <d-card>
        <d-card-body>
          <h3 style="text-align: center" class="mt-2 mb-4 text-primary">
            Reset password
          </h3>
          <d-alert
            v-if="sendError"
            theme="danger"
            show>
            An error occurred. Please try again.
          </d-alert>
          <d-alert
            v-if="sendErrorResult"
            theme="warning"
            show>
            {{ returnedErrors }}
          </d-alert>
          <d-alert
            v-if="sendSuccess"
            theme="success"
            show>
            Message with reset link has been sent.
          </d-alert>
          <validation-observer ref="password-reset-form" tag="form">
            <div class="form-group">
              <validation-provider
                rules="email"
                name="email"
                v-slot="{ errors }">
                <label class="text-center w-100">E-mail address:</label>
                <d-input
                  v-model="email"
                  name="email"
                  type="email"
                  :state="errors.length ? 'invalid' : null"
                  placeholder="E-mail address" />
                <div class="invalid-feedback">
                    {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
            <button
              type="submit"
              class="btn btn-pill btn-accent d-table mx-auto"
              @click.prevent="validateForm"
              :disabled="submitting">
              <template v-if="!submitting">Reset password</template>
              <template v-else>Sending&hellip;</template>
            </button>
          </validation-observer>
        </d-card-body>

        <d-card-footer class="text-center">
          <router-link to="/login">
            Back to login
          </router-link>
        </d-card-footer>
      </d-card>
    </div>
  </div>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';

export default {
  name: 'PasswordReset',
  data () {
    return {
      authError: false,
      submitting: false,
      sendSuccess: false,
      sendError: false,
      sendErrorResult: false,
      returnedErrors: '',
      email: ''
    }
  },
  methods: {
    clearError () {
      this.authError = false;
    },
    validateForm () {
      FormUtils.validate(this.$refs['password-reset-form'], this.resetPassword);
    },
    resetPassword () {
      this.clearError();
      this.sendSuccess = false;
      this.sendError = false;
      this.sendErrorResult = false;
      this.submitting = true;
      this.returnedErrors = '';

      this.$http.post('/password/email', {
        email: this.email
      }).then((response) => {
        this.submitting = false;

        if (response.data.success) {
          this.sendSuccess = true;
        } else {
          this.sendErrorResult = true;
          // eslint-disable-next-line
          this.returnedErrors = response.data.errors.join("\n");
        }
      }).catch((error) => {
        console.log(error);
        this.submitting = false;
        this.sendError = true;
      });
    }
  }
}
</script>

<style scoped>
.card-footer {
  background: #f5f5f5;
}
</style>
